import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Form, Input, InputNumber, Modal, Radio, Spin, Tag, Tooltip } from 'antd';
import 'moment/locale/es';
import { useState } from 'react';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../../common/request/authFetch';

export const NewCompetitorsModal = (props: {onFinish: any, onClose: any, isMyBusiness: boolean}) => {
		
	const [form] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);	
	const [updateData, setUpdateData] = useState(false);
	const { projectGroup } = useAuth();	

	const onFormFinish = async (values: any) => {

		const data = {
			...values,
			myBusiness: props.isMyBusiness
		};

		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/competitors`, { method: 'PUT', data }).then(() => { setUpdateData(!updateData) })
		props.onFinish();
	}	 
	
	return (

		<Modal open={true} onOk={() => form.submit()} onCancel={props.onClose} afterClose={form.resetFields}>

			{props.isMyBusiness ? <h2>Mi Negocio</h2> : <h2>Nuevo competidor</h2> }						
				
			<Form layout='vertical' form={form} onFinish={onFormFinish}>
				<Form.Item rules={[{ required: true }]} name="competitor" label='Nombre'>
					<Input placeholder='Tal y como aparece en Google Maps'/>
				</Form.Item>
			</Form>			
			<div style={{display:'flex', justifyContent:'center'}}><Spin size='large' spinning={isLoading}/></div>
		
		</Modal>
	)
}